import React, { useMemo } from "react";
import SavedPagerAndroid from "./SavedPagerAndroid";
import SavedPagerIOS from "./SavedPagerIOS";

const isIOSDevice = () => {
  if (typeof navigator === "undefined") return false;

  const userAgent = navigator.userAgent || "";
  const platform = navigator.platform || "";
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  return (
    /iPad|iPhone|iPod/i.test(userAgent) ||
    (platform === "MacIntel" && maxTouchPoints > 1)
  );
};

/*
|-----------------------------------------------------------------------------
| Platform-specific Saved Pager
|-----------------------------------------------------------------------------
|
| iOS keeps native horizontal scroll-snap. Android uses the transform-based
| swipe model that already solved the same nested-scroll conflict in Focus
| Mode. Both implementations share the exact saved-page rendering component.
|
*/
const SavedPager = (props) => {
  const useIOSMethod = useMemo(() => isIOSDevice(), []);

  return useIOSMethod ? (
    <SavedPagerIOS {...props} />
  ) : (
    <SavedPagerAndroid {...props} />
  );
};

export default SavedPager;
